import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
  useMediaQuery,
} from "@mui/material";
// import { getUserById } from "../services/UsersService";
import { useUser } from "../contexts/UserContext";
// import { getUserId } from "../services/authService";
import { useTheme } from "@mui/material/styles";
import CustomLabel from "../components/CustomLabel";
import Sidebar from "../components/Sidebar";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import InventoryIcon from "@mui/icons-material/Inventory";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";
import GroupIcon from "@mui/icons-material/Group";
import CommunityIcon from "@mui/icons-material/Groups";
import InfoIcon from "@mui/icons-material/Info";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CategoryIcon from "@mui/icons-material/Category";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import StraightenIcon from "@mui/icons-material/Straighten";
import TuneIcon from "@mui/icons-material/Tune";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CampaignIcon from "@mui/icons-material/Campaign";
import { getAllVenues } from "../services/VenueService";
import { PaymentOutlined } from "@mui/icons-material";
import { COLORS } from "../assets/theme";


interface UserProfile {
  fullName: string;
  userName: string;
  email: string;
  password: string;
  address: string;
  phone: string;
  image: string;
}

const DashboardLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { user, setUser } = useUser();
  const [profile, setProfile] = useState<UserProfile | undefined>(undefined);

  const noNavRoutes = ["/login", "/signup", "/forgot-password"];
  const showNavBar = !noNavRoutes.includes(location.pathname);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfileClick = () => {
    setAnchorEl(null);
    navigate("/profile");
  };
  const handleEditVenuesClick = () => {
    setAnchorEl(null);
    navigate("/edit-venues");
  };
  const handleAllDataClick = () => {
    setAnchorEl(null);
    navigate("/all-data");
  };
  const handleLogout = () => {
    setAnchorEl(null);
    setUser(null);
    localStorage.clear();
    navigate("/login");
  };
  const [mobileOpen, setMobileOpen] = useState(false);
  const [venueName, setVenueName] = useState("");
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerWidth = 220;
  const collapsedWidth = 70;
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const params = useParams();
  const basePath = params.branchId
    ? `/dashboard/${params.branchId}`
    : "/dashboard";
  const menuItems = [
    { label: "Dashboard", icon: <HomeIcon />, to: `${basePath}` },
    {
      label: "Appointment",
      icon: <EventAvailableIcon />,
      to: `${basePath}/appointment`,
    },
    // { label: "Staff", icon: <InventoryIcon />, to: `${basePath}/staff` },
  
    {
      label: "Clients",
      icon: <PeopleIcon />,
      children: [
        {
          label: "Clients List",
          icon: <GroupIcon />,
          to: `${basePath}/clients/clients`,
        },
        {
          label: "Community",
          icon: <CommunityIcon />,
          to: `${basePath}/clients/community`,
        },
        // { label: "Clients info", icon: <InfoIcon />, to: `${basePath}/clients/info` },
      ],
    },
    {
      label: "Finance",
      icon: <PaymentOutlined />,
      children: [
        {
          label: "Invoices",
          icon: <ReceiptIcon />,
          to: `${basePath}/finance/invoices`,
        },
        // {
        //   label: "Quotations",
        //   icon: <RequestQuoteIcon />,
        //   to: `${basePath}/finance/quotations`,
        // },
        {
          label: "Expenses",
          icon: <AccountBalanceWalletIcon />,
          to: `${basePath}/finance/expenses`,
        },
        {
          label: "Reports",
          icon: <AssessmentIcon />,
          to: `${basePath}/finance/reports`,
        },
      ],
    },
      {
      label: "User Notifications",
      icon: <NotificationsIcon />,
      to: `${basePath}/userNotifications`,
    },
    {
      label: "Banners",
      icon: <CampaignIcon />,
      to: `${basePath}/banners`,
    },
    {
      label: "PromoCode",
      icon: <LocalOfferIcon />,
      to: `${basePath}/promocode`,
    },
    {
      label: "Settings",
      icon: <SettingsIcon />,
      children: [
        // {
        //   label: "Specialities",
        //   icon: <CategoryIcon />,
        //   to: `${basePath}/settings/specialities`,
        // },
        {
          label: "Services",
          icon: <MiscellaneousServicesIcon />,
          to: `${basePath}/settings/services`,
        },
        {
          label: "Currencies",
          icon: <CurrencyExchangeIcon />,
          to: `${basePath}/settings/currencies`,
        },
        {
          label: "Units",
          icon: <StraightenIcon />,
          to: `${basePath}/settings/units`,
        },
        {
          label: "Advanced",
          icon: <TuneIcon />,
          to: `${basePath}/settings/advanced`,
        },
      ],
    },
  ];

  useEffect(() => {
    if (user) {
      setProfile({
        fullName: user.name || "",
        userName: user.name || "",
        email: user.email || "",
        password: "********",
        address: user.address || "",
        phone: user.mobile ? `${user.country_code || ""} ${user.mobile}` : "",
        image: user.banner || "",
      });
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    const fetchVenueName = async () => {
      if (params.branchId) {
        try {
          const venues = await getAllVenues();
          const venue = venues.find((v: any) => v.id === params.branchId);
          if (venue) {
            setVenueName(venue.name || "");
          }
        } catch (error) {
          console.error("Error fetching venue name:", error);
        }
      }
    };
    fetchVenueName();
  }, [params.branchId]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: COLORS.MainBackground,
        overflowX: "hidden",
      }}
    >
      {showNavBar && (
        <AppBar
          position="fixed"
          color="primary"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: { xs: 1, sm: 2 },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
              <CustomLabel
                text="Dashboard"
                onClick={() => navigate("/")}
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 0.8,
                  },
                }}
              />
            </Box>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                onClick={handleAvatarClick}
                sx={{
                  ml: 1,
                  p: 0,
                  width: { xs: 32, sm: 40 },
                  height: { xs: 32, sm: 40 },
                }}
              >
                <Avatar
                  src={profile?.image || ""}
                  alt={profile?.fullName || "Profile"}
                  sx={{ width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 } }}
                />
              </IconButton>
            </div>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  width: { xs: 180, sm: 200 },
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                },
              }}
            >
              <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
              <MenuItem onClick={handleEditVenuesClick}>Edit Venues</MenuItem>
              <MenuItem onClick={handleAllDataClick}>All Data</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      )}
      <Sidebar
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
        sidebarCollapsed={sidebarCollapsed}
        onSidebarToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
        menuItems={menuItems}
        venueName={venueName}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pr: { xs: 2, sm: 4 },
          pl: { xs: 2, sm: 3 },
          mt: { xs: 7, sm: 8 },
          boxSizing: "border-box",
          width: isSmUp
            ? `calc(100% - ${
                sidebarCollapsed ? collapsedWidth : drawerWidth
              }px)`
            : "100%",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.short,
          }),
          maxWidth: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          "& > *": { minWidth: 0 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;
